import { IconSystem } from '#icons/IconSystem';

import styles from './ScrollToTop.module.scss';

type Props = {
	className?: string;
};

export function ScrollToTop({ className }: Props) {
	return (
		<div className={`${styles.wrapper} ${className}`}>
			<button
				className={`${styles.scrollTopButton} heading4`}
				onClick={() => {
					window.scrollTo({ top: 0, behavior: 'smooth' });
				}}
			>
				<IconSystem icon="chevron-up" variant="filled" size="l" title="" className={styles.image} aria-hidden={true} />
				<span> nach oben </span>
			</button>
		</div>
	);
}
